import { Outlet } from "react-router-dom";

const HospitalModuleRoutes = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default HospitalModuleRoutes;
